import { render, staticRenderFns } from "./EditReportDetails.vue?vue&type=template&id=2344b02e&scoped=true&"
import script from "./EditReportDetails.vue?vue&type=script&lang=js&"
export * from "./EditReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2344b02e",
  null
  
)

export default component.exports